import { atom } from "jotai";

export const dateFiltersAtom = atom<any>({
  dataType: "Sum",
  dateType: "2022",
});
